import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../images/dashboard/logo.png'
import calender from '../images/dashboard/Calendar.png'
import bag from '../images/dashboard/bag.png'
import { toast } from 'react-toastify';
// import eye from '../images/dashboard/eye.png'
// import edit from '../images/dashboard/edit.png'
// import deleteimg from '../images/dashboard/delete.png'
import processimg from '../images/dashboard/Process.png'
import verified from '../images/dashboard/Verified.png'
import income from '../images/dashboard/Income.png'
import CryptoJS from "crypto-js";
import TrackingOrders from '../adminSide/TrackingOrders'
import axios from 'axios'
import { ExternalLink } from "lucide-react";
import AdminHeader from '../components/AdminHeader';

function Dashboard() {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]); // This will now hold ALL loaded orders
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState(null);
    const [customerNames, setCustomerNames] = useState({});
    const [productNames, setProductNames] = useState({});
    const [productDetails, setProductDetails] = useState({});
    const [customerAddresses, setCustomerAddresses] = useState({});

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const LedName = localStorage.getItem('loginName') || 'unknown';

    const [modifiedColors, setModifiedColors] = useState({});


    useEffect(() => {
        const fetchModfiedColors = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const data = await response.json();
                // console.log(data,'data');

                const modifiedColors = data.reduce((acc, item) => {
                    acc[item.db_color] = {
                        name: item.md_color?.toUpperCase() || '',
                        hex: item.hex || ''
                    };
                    return acc;
                }, {});

                setModifiedColors(modifiedColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };
        fetchModfiedColors()
    }, [])

    const fetchCustomerName = async (ledCode) => {
        try {
            const response = await fetch(`${apiBaseUrl}/user/getAddresses/BLACKBATON_2526/${ledCode}`);
            if (!response.ok) {
                throw new Error('Failed to fetch customer data');
            }
            const data = await response.json();
            if (data.success && data.data.length > 0) {
                const activeAddress = data.data.find(address => address.isActive) || data.data[0];
                return {
                    name: activeAddress.name,
                    addressData: activeAddress
                };
            }
            return {
                name: 'Unknown Customer',
                addressData: null
            };
        } catch (error) {
            console.error('Error fetching customer name:', error);
            return {
                name: 'Unknown Customer',
                addressData: null
            };
        }
    };

    // Add this function to fetch product name
    const fetchProductName = async (itemId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/getProductById/BLACKBATON_2526?Id=${itemId}`);
            if (!response.ok) throw new Error('Failed to fetch product data');

            const data = await response.json();
            return data.length > 0 ? data[0].ItemName : 'Unknown Product';

        } catch (error) {
            console.error('Error fetching product name:', error);
            return 'Unknown Product';
        }
    };


    // Add this function to fetch product details
    const fetchProductDetails = async (uniqueCode) => {
        try {
            const response = await fetch(`${apiBaseUrl}/getProductByUniqueCode/BLACKBATON_2526?uniqueCode=${uniqueCode}`);
            if (!response.ok) {
                throw new Error('Failed to fetch product details');
            }
            const data = await response.json();
            return data.length > 0 ? data[0] : null;
        } catch (error) {
            console.error('Error fetching product details:', error);
            return null;
        }
    };


    const [searchItem, setSearchItem] = useState('')
    const [filterDate, setFilterDate] = useState('')
    const [status, setStatus] = useState('')

    const handleSearch = (e) => {
        setSearchItem(e.target.value)
    }

    const SECRET_KEY = "shersoft_blackbaton_delhivery";

    const encryptText = (text) => {
        return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
    };

    const [showTracking, setShowTracking] = useState(null);
    const [oLedCode, setOLedCode] = useState(null);

    const handleTrackOrder = (order_id, led) => {
        setShowTracking(order_id)
        setOLedCode(led)
    };

    const trackingStatuses = [
        "Manifested",
        "In Transit",
        "Out for Delivery",
        "Delivered",
        "Order Cancelled",
        "RTO (Return to Origin)",
        "Undelivered",
        "Rejected"
    ];

    const getBackendStatus = (s) => {
        if (!s) return '';
        if (s === 'success' || s === 'Delivered') return 'success';
        return 'pending';
    };

    useEffect(() => {
        if (showTracking) {
            // Disable body scroll
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        } else {
            // Enable body scroll
            document.body.style.overflow = 'auto';
            document.body.style.position = 'static';
        }

        // Cleanup function
        return () => {
            document.body.style.overflow = 'auto';
            document.body.style.position = 'static';
        };
    }, [showTracking]);

    // Reset pagination when filters change
    useEffect(() => {
        setOrders([]);
        setPage(1);
        setHasMore(true);
        setLoading(true);
        fetchOrders(1, true);
    }, [apiBaseUrl, searchItem, filterDate, status]);

    // Fetch orders function
    const fetchOrders = async (pageNum, isReset = false) => {
        try {
            if (pageNum > 1) setLoadingMore(true);

            // Construct URL with pagination and filters
            const params = new URLSearchParams();
            params.append('page', pageNum);
            params.append('pageSize', 20);
            if (filterDate) params.append('date', filterDate);
            if (status) params.append('status', getBackendStatus(status));
            if (searchItem) params.append('search', searchItem);

            const response = await fetch(`${apiBaseUrl}/allorder/list/BLACKBATON_2526?${params.toString()}`);
            if (!response.ok) {
                throw new Error('Failed to fetch orders');
            }

            const data = await response.json();
            if (!data.success) {
                if (pageNum === 1) setLoading(false);
                setLoadingMore(false);
                return;
            }

            // New Orders from backend (raw list)
            const newOrdersRaw = data.orders || [];

            if (newOrdersRaw.length < 20) {
                setHasMore(false);
            }

            // GROUPING LOGIC (Applied to the newly fetched batch)
            const map = new Map();
            newOrdersRaw.forEach(item => {
                if (!map.has(item.EntryNo)) {
                    map.set(item.EntryNo, {
                        EntryNo: item.EntryNo,
                        LedCode: item.LedCode,
                        OrderDate: item.OrderDate,
                        OrderTime: item.OrderTime,
                        isDelivered: item.isDelivered,
                        PhoneNo: item.PhoneNo,
                        Total: 0,
                        data: []
                    });
                }
                const group = map.get(item.EntryNo);
                group.Total += Number(item.Total) || 0;
                group.data.push({
                    Itemid: item.Itemid,
                    UniqueCode: item.UniqueCode,
                    Quantity: item.Quantity,
                    SRate: item.SRate,
                    subTotal: item.Total,
                    mrp: item.mrp
                });
            });

            const newGroupedOrders = Array.from(map.values());

            // Update State
            if (isReset) {
                setOrders(newGroupedOrders);
            } else {
                setOrders(prev => {
                    // Avoid duplicates just in case
                    const existingIds = new Set(prev.map(o => o.EntryNo));
                    const uniqueNew = newGroupedOrders.filter(o => !existingIds.has(o.EntryNo));
                    return [...prev, ...uniqueNew];
                });
            }

            setLoading(false);
            setLoadingMore(false);

            // POST-FETCH PROCESSES (Child Data)
            // Only run for the new batch
            if (newGroupedOrders.length > 0) {
                const visibleOrders = newGroupedOrders;

                // 1. Product Names
                const uniqueItemIds = [...new Set(newOrdersRaw.map(o => o.Itemid))];
                await Promise.all(
                    uniqueItemIds.map(async (id) => {
                        if (!productNames[id]) { // Check cache
                            const name = await fetchProductName(id);
                            setProductNames(prev => ({ ...prev, [id]: name }));
                        }
                    })
                );

                // 2. Customer & Product Details
                const uniqueLedCodes = [...new Set(visibleOrders.map(order => order.LedCode))];

                await Promise.all([
                    ...uniqueLedCodes.map(async (code) => {
                        if (!customerNames[code]) { // Check cache
                            const { name, addressData } = await fetchCustomerName(code);
                            setCustomerNames(prev => ({ ...prev, [code]: name }));
                            setCustomerAddresses(prev => ({ ...prev, [code]: addressData }));
                        }
                    }),
                    ...visibleOrders.flatMap(order =>
                        order.data.map(async (item) => {
                            if (!productDetails[item.UniqueCode]) { // Check cache
                                const details = await fetchProductDetails(item.UniqueCode);
                                if (details) {
                                    setProductDetails(prev => ({ ...prev, [item.UniqueCode]: details }));
                                }
                            }
                        })
                    )
                ]);

                // 3. Tracking
                visibleOrders.forEach(order => {
                    fetchOrderTrackingStatus(order.EntryNo);
                });
            }

        } catch (err) {
            setError(err.message);
            setLoading(false);
            setLoadingMore(false);
        }
    };

    // Scroll detection for pagination
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = document.documentElement.clientHeight;

            // Load more when scrolled to 80% of page
            if (scrollTop + clientHeight >= scrollHeight * 0.8) {
                if (!loadingMore && hasMore) {
                    const nextPage = page + 1;
                    setPage(nextPage);
                    fetchOrders(nextPage);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loadingMore, hasMore, page]);

    // Update displayed orders when allOrders changes




    // Add this function inside your Dashboard component
    const handleMarkAsDelivered = async (entryNo) => {

        try {
            const response = await fetch(`${apiBaseUrl}/order/update-delivery/BLACKBATON_2526/${entryNo}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to update delivery status');
            }

            const data = await response.json();

            if (data.success) {
                // Update the orders state to reflect the change
                setOrders(prevOrders =>
                    prevOrders.map(order =>
                        order.EntryNo === entryNo ? { ...order, isDelivered: true } : order
                    )
                );
            }
        } catch (error) {
            console.error('Error updating delivery status:', error);
            // You might want to show an error message to the user here
        }
    };

    const homePage = () => {
        navigate('/');
    }

    const imageuploadpage = () => {
        navigate('/imageupload');
    }

    const offerUpdatepage = () => {
        navigate('/offerupdate');
    }

    const categoryaddpage = () => {
        navigate('/subcategoryadd');
    }

    const handleAllColorsUpdate = () => {
        navigate('/updateColors');
    }

    const handleAllProductsUpdate = () => {
        navigate('/updateProducts');
    }



    const [orderTrackingStatus, setOrderTrackingStatus] = useState({});
    const [sendingToDelhivery, setSendingToDelhivery] = useState({});

    // console.log(orderTrackingStatus, 'orderTrackingStatus');

    // Add this function to format time ago
    const formatTimeAgo = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffDays > 0) return `${diffDays}d ago`;
        if (diffHours > 0) return `${diffHours}h ago`;
        if (diffMins > 0) return `${diffMins}m ago`;
        return 'Just now';
    };


    // Get the latest tracking status from tracking data
    const getCurrentTrackingStatus = (trackingData) => {
        if (!trackingData?.ShipmentData?.[0]?.Shipment?.Scans) return 'Pending';

        const scans = trackingData.ShipmentData[0].Shipment.Scans;

        // IMPORTANT: The scans array is already in chronological order (oldest first)
        // So the LAST element is the most recent scan
        let latestValidScan = null;

        // Find the latest valid scan with ScanDetail
        for (let i = scans.length - 1; i >= 0; i--) {
            const scan = scans[i];
            if (scan.ScanDetail) {
                latestValidScan = scan.ScanDetail;
                break;
            }
        }

        // If no valid scans found, check the shipment status
        if (!latestValidScan) {
            return trackingData?.ShipmentData?.[0]?.Shipment?.Status?.Status || 'Pending';
        }

        // Check for cancellation scans
        const scanText = latestValidScan.Scan || '';
        const statusCode = latestValidScan.StatusCode || '';

        if (scanText === 'Not Picked' || statusCode === 'X-PNP') {
            return 'Order Cancelled';
        }

        if (scanText.toLowerCase().includes('cancel')) {
            return 'Cancelled';
        }

        if (scanText.toLowerCase().includes('rto')) {
            return 'RTO (Return to Origin)';
        }

        if (scanText.toLowerCase().includes('undelivered')) {
            return 'Undelivered';
        }

        if (scanText.toLowerCase().includes('rejected')) {
            return 'Rejected';
        }

        // Return the actual scan text
        return scanText;
    };

    // Alternative: Get ALL scans and find the most recent
    const getLatestTrackingStatus = (trackingData) => {
        if (!trackingData?.ShipmentData?.[0]?.Shipment?.Scans) return 'Pending';

        const allScans = [];

        // Extract all valid scans with their timestamps
        trackingData.ShipmentData[0].Shipment.Scans.forEach(scan => {
            if (scan.ScanDetail) {
                allScans.push({
                    scan: scan.ScanDetail.Scan || 'Unknown',
                    scanDateTime: scan.ScanDetail.ScanDateTime || scan.ScanDetail.StatusDateTime || '',
                    instructions: scan.ScanDetail.Instructions || '',
                    statusCode: scan.ScanDetail.StatusCode || '',
                    scannedLocation: scan.ScanDetail.ScannedLocation || ''
                });
            }
        });

        // If no scans found, return default status
        if (allScans.length === 0) {
            return trackingData?.ShipmentData?.[0]?.Shipment?.Status?.Status || 'Pending';
        }

        // Sort by datetime (most recent first)
        allScans.sort((a, b) => {
            const dateA = new Date(a.scanDateTime);
            const dateB = new Date(b.scanDateTime);
            return dateB - dateA; // Descending (newest first)
        });

        const latestScan = allScans[0];

        // Check for cancellation status
        return checkAndFormatStatus(latestScan.scan, latestScan.statusCode);
    };

    // Helper function to check and format status
    const checkAndFormatStatus = (scanText, statusCode) => {
        if (!scanText) return 'Pending';

        const text = scanText.toLowerCase();

        // Check cancellation statuses
        if (text === 'not picked' || statusCode === 'X-PNP' || statusCode === 'PNP') {
            return 'Order Cancelled';
        }

        if (text.includes('cancel')) {
            return 'Cancelled';
        }

        if (text.includes('rto')) {
            return 'RTO (Return to Origin)';
        }

        if (text.includes('undelivered')) {
            return 'Undelivered';
        }

        if (text.includes('rejected')) {
            return 'Rejected';
        }

        // Return the original scan text for other statuses
        return scanText;
    };

    // Get status with timestamp for debugging
    const getLatestTrackingStatusWithTime = (trackingData) => {
        if (!trackingData?.ShipmentData?.[0]?.Shipment?.Scans) {
            return {
                status: 'Pending',
                timestamp: null,
                location: null
            };
        }

        const scans = trackingData.ShipmentData[0].Shipment.Scans;
        let latestScan = null;

        // Find the most recent valid scan
        for (let i = scans.length - 1; i >= 0; i--) {
            const scan = scans[i];
            if (scan.ScanDetail) {
                latestScan = scan.ScanDetail;
                break;
            }
        }

        if (!latestScan) {
            return {
                status: trackingData?.ShipmentData?.[0]?.Shipment?.Status?.Status || 'Pending',
                timestamp: null,
                location: null
            };
        }

        const status = checkAndFormatStatus(latestScan.Scan, latestScan.StatusCode);

        return {
            status,
            timestamp: latestScan.ScanDateTime || latestScan.StatusDateTime,
            location: latestScan.ScannedLocation,
            instructions: latestScan.Instructions
        };
    };

    // Status color mapping
    // Status color mapping - Handle cancelled status
    const getStatusColor = (status) => {
        if (!status) return 'text-gray-600';

        const statusLower = status.toLowerCase();

        if (statusLower.includes('delivered')) return 'text-green-600';
        if (statusLower.includes('dispatched') || statusLower.includes('out for delivery')) return 'text-purple-600';
        if (statusLower.includes('transit')) return 'text-blue-600';
        if (statusLower.includes('manifested') || statusLower.includes('pickup')) return 'text-blue-600';

        // CANCELLED STATUSES - All in red
        if (statusLower.includes('cancel') ||
            statusLower.includes('rto') ||
            statusLower.includes('undelivered') ||
            statusLower.includes('rejected') ||
            statusLower.includes('not picked')) {
            return 'text-red-600';
        }

        if (statusLower.includes('pending')) return 'text-yellow-600';

        return 'text-gray-600';
    };

    // Status icon mapping
    const getStatusIcon = (status) => {
        if (!status) return '?';

        const statusLower = status.toLowerCase();

        if (statusLower.includes('delivered')) return '?';
        if (statusLower.includes('out for delivery') || statusLower.includes('dispatched')) return '??';
        if (statusLower.includes('transit')) return '?';
        if (statusLower.includes('manifested')) return '??';
        if (statusLower.includes('pickup')) return '??';

        // CANCELLED STATUSES
        if (statusLower.includes('cancel') ||
            statusLower.includes('rto') ||
            statusLower.includes('undelivered') ||
            statusLower.includes('rejected') ||
            statusLower.includes('not picked')) {
            return '?';
        }

        if (statusLower.includes('pending')) return '?';

        return '?';
    };

    // Function to fetch tracking status for an order
    const fetchOrderTrackingStatus = async (orderId) => {
        try {
            const res = await fetch(`${apiBaseUrl}/tracking-by-orderId/${orderId}`);
            const data = await res.json();

            if (res.ok && data.success && data.awb) {
                try {
                    const trackingRes = await axios.get(`${apiBaseUrl}/track-delhivery/${data.awb}`);
                    if (trackingRes.data.success) {
                        // Get LATEST status using the new function
                        const statusInfo = getLatestTrackingStatusWithTime(trackingRes.data.data);

                        setOrderTrackingStatus(prev => ({
                            ...prev,
                            [orderId]: {
                                status: statusInfo?.status,
                                timestamp: statusInfo.timestamp,
                                location: statusInfo.location,
                                awb: data.awb
                            }
                        }));

                        return statusInfo?.status;
                    }
                } catch (err) {
                    console.error('Tracking fetch error:', err);
                }
            } else if (res.ok && data.success && !data.awb) {
                setOrderTrackingStatus(prev => ({
                    ...prev,
                    [orderId]: {
                        status: 'Manifest Pending',
                        timestamp: '',
                        location: '',
                        awb: ''
                    }
                }));

                return 'Manifest Pending';
            } else {
                setOrderTrackingStatus(prev => ({
                    ...prev,
                    [orderId]: {
                        status: 'Not Found',
                        timestamp: '',
                        location: '',
                        awb: ''
                    }
                }));

                return 'Not Found';
            }
        } catch (err) {
            console.error('Order tracking error:', err);
        }

        // Return default if fetch fails
        return 'Pending';
    };

    const isManifestPending = (tracking) => {
        if (!tracking?.status) return false;
        return tracking.status.trim().toLowerCase() === 'manifest pending';
    };

    const canTrackOrder = (tracking) => {
        return Boolean(tracking?.awb);
    };

    const buildShipmentPayload = (order) => {
        const customerAddress = customerAddresses[order.LedCode];

        if (!customerAddress) {
            throw new Error('Customer address not available yet. Please retry in a moment.');
        }

        const cartItems = (order.data || []).map((item) => ({
            itemId: item.Itemid,
            itemName: productNames[item.Itemid] || `Item ${item.Itemid}`,
            itemPrice: Number(item.SRate) || 0,
            quantity: Number(item.Quantity) || 1,
            uniqueCode: item.UniqueCode
        }));

        const payload = {
            orderId: order.EntryNo,
            date: new Date().toISOString().split('T')[0],
            customerAddress: {
                name: customerAddress?.name || customerNames[order.LedCode] || 'Customer',
                address: customerAddress?.address || '',
                city: customerAddress?.city || customerAddress?.district || '',
                district: customerAddress?.district || customerAddress?.city || '',
                state: customerAddress?.state || '',
                pincode: customerAddress?.pincode || '',
                mobile: customerAddress?.mobile || order.PhoneNo || '',
                email: customerAddress?.email || '',
                type: customerAddress?.addressType || 'Home'
            },
            cartItems
        };

        const requiredFields = ['name', 'address', 'city', 'state', 'pincode', 'mobile'];
        const missingField = requiredFields.find((field) => !String(payload.customerAddress[field] || '').trim());
        if (missingField) {
            throw new Error(`Address is incomplete (${missingField}). Please update customer address first.`);
        }
        if (!payload.cartItems.length) {
            throw new Error('Order items are missing for this order.');
        }

        return payload;
    };

    const handleSendToDelhivery = async (order) => {
        try {
            setSendingToDelhivery((prev) => ({ ...prev, [order.EntryNo]: true }));

            const shipmentPayload = buildShipmentPayload(order);

            const response = await fetch(`${apiBaseUrl}/create-delhivery-shipment/BLACKBATON_2526`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(shipmentPayload),
            });

            const result = await response.json();
            if (!response.ok || !result?.success) {
                throw new Error(result?.message || result?.error || 'Failed to send shipment to Delhivery.');
            }

            await fetchOrderTrackingStatus(order.EntryNo);

            const successMessage = result?.awb
                ? `Order #${order.EntryNo} sent to Delhivery successfully.`
                : `Order #${order.EntryNo} submitted. AWB is still pending.${result?.pendingReason ? ` Reason: ${result.pendingReason}` : ''}`;
            toast.info(successMessage);
        } catch (err) {
            console.error('Error while sending shipment to Delhivery:', err);
            toast.info(err?.message || 'Unable to send this order to Delhivery right now.');
        } finally {
            setSendingToDelhivery((prev) => ({ ...prev, [order.EntryNo]: false }));
        }
    };
    // Fetch tracking status for all orders when component mounts or orders change
    // useEffect(() => {
    //     if (orders.length > 0) {
    //         orders.forEach(order => {
    //             fetchOrderTrackingStatus(order.EntryNo);
    //         });
    //     }
    // }, [orders]);


    const groupItemsByItemNameAndColor = (order, productDetails, productNames) => {
        const itemMap = {};

        order.data.forEach(item => {
            const details = productDetails[item.UniqueCode];
            if (!details) return;

            const itemName = productNames[item.Itemid] || "Unknown Product";
            const color = details.Color || "Unknown";
            const size = details.Size || "N/A";
            const itemId = details.ItemId || item.Itemid || "N/A";

            // Create item group if not exists
            if (!itemMap[itemName]) {
                itemMap[itemName] = {
                    itemId,     // ? store itemId once
                    colors: {}
                };
            }

            // Create color group if not exists
            if (!itemMap[itemName].colors[color]) {
                itemMap[itemName].colors[color] = [];
            }

            // Push size / quantity
            itemMap[itemName].colors[color].push({
                size,
                quantity: item.Quantity
            });
        });

        // Convert object ? array format
        return Object.keys(itemMap).map(itemName => ({
            itemName,
            itemId: itemMap[itemName].itemId,   // expose itemId here
            colors: Object.keys(itemMap[itemName].colors).map(color => ({
                color,
                items: itemMap[itemName].colors[color]
            }))
        }));
    };


    const fullimage = (id, itemName) => {
        navigate(`/fullimage?I=${btoa(String(id))}&N=${btoa(itemName)}`, { state: { id, itemName } });
    };


    // Calculate summary statistics based on filtered data
    const isCompleted = (order, tracking) => {
        return order.isDelivered || tracking?.status === 'Delivered';
    };

    const isInProcess = (order, tracking) => {
        if (isCompleted(order, tracking)) return false;
        const s = tracking?.status;
        // If not completed and not cancelled/returned, it's in process (even if "Not Found" or "Pending")
        if (s && (s.includes('Cancel') || s.includes('Rejected') || s.includes('RTO'))) return false;
        return true;
    };

    const displayOrders = orders.filter(order => {
        const tracking = orderTrackingStatus[order.EntryNo];
        const trackStatus = tracking?.status;

        if (status === 'pending') return !order.isDelivered;
        if (status === 'success' || status === 'Delivered') return isCompleted(order, tracking);

        if (status) {
            if (!trackStatus) return false;
            return trackStatus.trim() === status.trim();
        }
        return true;
    });

    // console.log(displayOrders,'displayOrders');
    

    const totalOrdersCount = displayOrders.length;
    const inProcessCount = displayOrders.filter(o => isInProcess(o, orderTrackingStatus[o.EntryNo])).length;
    const completedCount = displayOrders.filter(o => isCompleted(o, orderTrackingStatus[o.EntryNo])).length;

    const totalRevenue = displayOrders.reduce((sum, order) => {
        const tracking = orderTrackingStatus[order.EntryNo];
        const s = tracking?.status;
        const revenueStatuses = ["Manifested", "In Transit", "Out for Delivery", "Delivered"];
        const isValid = revenueStatuses.includes(s) || order.isDelivered;
        return sum + (isValid ? order.Total : 0);
    }, 0);

    // Function to format date to dd/mm/yyyy
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Loading state is now handled inline to preserve search input focus
    // if (loading) { ... } logic removed

    if (error) {
        return <div className='min-h-screen bg-gray-50 flex flex-col font-dmSans'>
            <AdminHeader />
            <div className="flex-grow flex justify-center items-center h-[calc(100vh-80px)] px-4">
                <div className="bg-white p-8 rounded-3xl shadow-xl border border-red-100 text-center max-w-md w-full">
                    <div className="w-16 h-16 bg-red-50 text-red-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                    </div>
                    <h2 className="text-xl font-bold text-gray-900 mb-2">Failed to load dashboard</h2>
                    <p className="text-gray-500 mb-6">{error}</p>
                    <button onClick={() => window.location.reload()} className="w-full py-3 bg-black text-white rounded-xl font-bold hover:bg-gray-800 transition-all">Retry Access</button>
                </div>
            </div>
        </div>
    }

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-dmSans">
            {/* Dashboard Header */}
            <AdminHeader />
            {/* Added spacing to compensate for header */}

            <div className="flex-grow py-8 lg:px-12 px-4">
                <div className="w-full max-w-7xl mx-auto">
                    {/* Mobile Stats - Show on small screens */}
                    {/* Mobile Stats - Show on small screens */}
                    <div className="lg:hidden grid grid-cols-2 gap-4 mb-6">
                        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-3">
                            <div className='w-8 h-8 rounded-lg bg-black flex justify-center items-center'>
                                <img src={bag} alt="Total Orders" className='w-4 h-4' />
                            </div>
                            <div className='flex flex-col'>
                                <p className="text-xl font-bold text-gray-900">{totalOrdersCount}</p>
                                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">Total Orders</p>
                            </div>
                        </div>
                        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-3">
                            <div className='w-8 h-8 rounded-lg bg-black flex justify-center items-center'>
                                <img src={processimg} alt="In Process" className='w-4 h-4' />
                            </div>
                            <div className='flex flex-col'>
                                <p className="text-xl font-bold text-gray-900">{inProcessCount}</p>
                                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">In Process</p>
                            </div>
                        </div>
                        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-3">
                            <div className='w-8 h-8 rounded-lg bg-black flex justify-center items-center'>
                                <img src={verified} alt="Completed" className='w-4 h-4' />
                            </div>
                            <div className='flex flex-col'>
                                <p className="text-xl font-bold text-gray-900">{completedCount}</p>
                                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">Completed</p>
                            </div>
                        </div>
                        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-3">
                            <div className='w-8 h-8 rounded-lg bg-black flex justify-center items-center'>
                                <img src={income} alt="Revenue" className='w-4 h-4' />
                            </div>
                            <div className='flex flex-col'>
                                <p className="text-xl font-bold text-gray-900">?{totalRevenue.toLocaleString()}</p>
                                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">Revenue</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white shadow-2xl rounded-b-3xl border-x border-b border-gray-100 overflow-hidden">
                        {/* Summary Cards Grid (Optional, let's keep it for visual richness but simplified) */}
                        <div className='hidden lg:grid grid-cols-2 lg:grid-cols-4 p-8 gap-6 border-b border-gray-50'>
                            {[
                                { label: 'Total Orders', value: totalOrdersCount, icon: bag, color: 'bg-black' },
                                { label: 'In Process', value: inProcessCount, icon: processimg, color: 'bg-black' },
                                { label: 'Completed', value: completedCount, icon: verified, color: 'bg-black' },
                                { label: 'Revenue', value: `?${totalRevenue.toLocaleString()}`, icon: income, color: 'bg-black' }
                            ].map((card, i) => (
                                <div key={i} className='flex items-center gap-4 p-4 rounded-2xl bg-gray-50/50 border border-gray-100 hover:bg-white hover:shadow-lg transition-all'>
                                    <div className={`w-10 h-10 rounded-xl ${card.color} flex justify-center items-center shadow-lg shadow-black/10`}>
                                        <img src={card.icon} alt={card.label} className='w-5 h-5' />
                                    </div>
                                    <div className='flex flex-col'>
                                        <span className='text-lg font-bold text-gray-900'>{card.value}</span>
                                        <span className='text-[10px] font-bold uppercase tracking-widest text-gray-400'>{card.label}</span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Order Management Section */}
                        <section className='w-full'>
                            {/* Filter Bar */}
                            <div className='p-8 border-b border-gray-100 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 bg-gray-50/20'>
                                <div className='flex flex-col gap-1'>
                                    <h2 className='text-xl font-bold text-gray-900'>Order Management</h2>
                                    <p className='text-xs font-semibold text-gray-400 uppercase tracking-widest'>Total {displayOrders.length} orders found</p>
                                </div>

                                <div className='flex flex-wrap items-center gap-3 w-full lg:w-auto'>
                                    {/* Date Filter */}
                                    <div className='relative flex-grow lg:flex-grow-0'>
                                        <input
                                            type="date"
                                            className='w-full lg:w-40 bg-white border border-gray-200 rounded-xl px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-black/5 focus:border-black transition-all'
                                            value={filterDate}
                                            onChange={(e) => setFilterDate(e.target.value)}
                                        />
                                    </div>

                                    {/* Status Filter */}
                                    <div className='relative flex-grow lg:flex-grow-0'>
                                        <select
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            className='w-full lg:w-40 bg-white border border-gray-200 rounded-xl px-4 py-2 text-sm font-medium appearance-none focus:outline-none focus:ring-2 focus:ring-black/5 focus:border-black transition-all cursor-pointer'
                                        >
                                            <option value="">All Status</option>
                                            {/* <option value="pending">Pending</option>
                                            <option value="success">Success</option> */}
                                            {trackingStatuses.map(s => (
                                                <option key={s} value={s}>{s}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Search Input */}
                                    <div className='relative flex-grow'>
                                        <input
                                            type="text"
                                            className='w-full bg-white border border-gray-200 rounded-xl px-4 py-2 pl-10 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-black/5 focus:border-black transition-all'
                                            value={searchItem}
                                            placeholder='Search...'
                                            onChange={handleSearch}
                                        />
                                        <svg className='absolute left-3 top-2.5 w-4 h-4 text-gray-400' fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                    </div>

                                    {/* Reset Button */}
                                    <button
                                        onClick={() => { setSearchItem(''); setFilterDate(''); setStatus(''); }}
                                        className='p-2 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-xl transition-colors shadow-sm'
                                        title="Reset Filters"
                                    >
                                        <svg className='w-5 h-5' fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
                                    </button>
                                </div>
                            </div>

                            {/* Desktop Table */}
                            <div className='hidden lg:block overflow-x-auto'>
                                <table className='w-full text-left border-collapse'>
                                    <thead>
                                        <tr className='bg-black text-white'>
                                            <th className='px-6 py-4 text-[10px] uppercase font-bold tracking-widest border-r border-white/10'>Customer</th>
                                            <th className='px-6 py-4 text-[10px] uppercase font-bold tracking-widest border-r border-white/10'>Products</th>
                                            <th className='px-6 py-4 text-[10px] uppercase font-bold tracking-widest border-r border-white/10'>Shipping Address</th>
                                            <th className='px-6 py-4 text-[10px] uppercase font-bold tracking-widest border-r border-white/10 text-center'>Order ID</th>
                                            <th className='px-6 py-4 text-[10px] uppercase font-bold tracking-widest text-center'>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="5" className='px-6 py-24 text-center'>
                                                    <div className="flex flex-col items-center gap-4">
                                                        <div className="w-12 h-12 border-4 border-gray-100 border-t-black rounded-full animate-spin"></div>
                                                        <span className="text-sm font-bold text-gray-400 uppercase tracking-widest">Loading Orders...</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : displayOrders.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className='px-6 py-12 text-center text-gray-400 font-medium'>
                                                    No orders were found.
                                                </td>
                                            </tr>
                                        ) : (
                                            displayOrders.map((order, index) => {
                                                const tracking = orderTrackingStatus[order.EntryNo];
                                                const showSendToDelhiveryBtn = isManifestPending(tracking);
                                                const isSendingToDelhivery = !!sendingToDelhivery[order.EntryNo];
                                                return (
                                                    <tr
                                                        key={`${index}-${searchItem}-${filterDate}-${status}`}
                                                        className={`group transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'} hover:bg-blue-50/30`}
                                                    >
                                                        <td className='px-6 py-6 border-r border-gray-100'>
                                                            <div className='flex flex-col'>
                                                                <span className='text-sm font-bold text-gray-900'>
                                                                    {customerNames[order.LedCode] || 'Loading...'}
                                                                </span>
                                                                <span className='text-[11px] font-bold text-gray-400 uppercase tracking-tight mt-0.5'>ID {order.LedCode}</span>
                                                                <span className='text-[11px] font-medium text-gray-500 mt-2 bg-gray-100 w-fit px-2 py-0.5 rounded-full'>
                                                                    {formatDate(order.OrderDate)}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td className='px-6 py-6 border-r border-gray-100'>
                                                            <div className='flex flex-col gap-4 max-w-sm'>
                                                                {(() => {
                                                                    const grouped = groupItemsByItemNameAndColor(order, productDetails, productNames);

                                                                    // SKELETON LOADER
                                                                    if (grouped.length === 0 && order.data && order.data.length > 0) {
                                                                        return (
                                                                            <div className="space-y-3 animate-pulse">
                                                                                {[1, 2].map((_, i) => (
                                                                                    <div key={i} className="space-y-2">
                                                                                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                                                                                        <div className="flex gap-2">
                                                                                            <div className="h-10 w-16 bg-gray-100 rounded-xl border border-gray-200"></div>
                                                                                            <div className="h-10 w-16 bg-gray-100 rounded-xl border border-gray-200"></div>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        );
                                                                    }

                                                                    return grouped.map((itemGroup, itemIdx) => (
                                                                        <div key={itemIdx} className="space-y-2">
                                                                            <div
                                                                                className="inline-flex items-center gap-2 group/link cursor-pointer"
                                                                                onClick={() => fullimage(itemGroup.itemId, itemGroup.itemName)}
                                                                            >
                                                                                <span className='text-sm font-bold text-gray-900 group-hover/link:text-blue-600 border-b border-transparent group-hover/link:border-blue-600 transition-all'>
                                                                                    {itemGroup.itemName}
                                                                                </span>
                                                                                <ExternalLink className="w-3.5 h-3.5 text-gray-400 group-hover/link:text-blue-600" />
                                                                            </div>
                                                                            <div className='flex flex-wrap gap-2'>
                                                                                {itemGroup.colors.map((colorGroup, colorIdx) => {
                                                                                    const colorHex = modifiedColors[colorGroup.color]?.hex;
                                                                                    return (
                                                                                        <div key={colorIdx} className="flex flex-col gap-1.5 p-2 rounded-xl border border-gray-100 bg-white shadow-sm min-w-[120px]">
                                                                                            <div className='flex items-center gap-2'>
                                                                                                <div className='w-3 h-3 rounded-full border border-gray-300' style={{ backgroundColor: colorHex || 'transparent' }} />
                                                                                                <span className="text-[10px] font-bold uppercase text-gray-600">{colorGroup.color}</span>
                                                                                            </div>
                                                                                            {colorGroup.items.map((item, sizeIdx) => (
                                                                                                <span key={sizeIdx} className="text-[11px] font-medium text-gray-500">
                                                                                                    Size {item.size} <span className='text-gray-300 mx-1'>|</span> Qty {item.quantity}
                                                                                                </span>
                                                                                            ))}
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    ));
                                                                })()}
                                                            </div>
                                                        </td>
                                                        <td className='px-6 py-6 border-r border-gray-100'>
                                                            <div className='flex flex-col gap-1.5'>
                                                                <div className='flex items-center gap-2 text-gray-600'>
                                                                    <svg className='w-3.5 h-3.5' fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                                                                    <span className='text-xs font-bold'>{order.PhoneNo}</span>
                                                                </div>
                                                                {customerAddresses[order.LedCode] && (
                                                                    <div className='text-xs text-gray-500 font-medium leading-relaxed mt-1'>
                                                                        <p className='text-gray-900 font-semibold mb-1'>{customerAddresses[order.LedCode].address}</p>
                                                                        <p>{customerAddresses[order.LedCode].locality}, {customerAddresses[order.LedCode].city}</p>
                                                                        <p>{customerAddresses[order.LedCode].district}, {customerAddresses[order.LedCode].pincode}</p>
                                                                        <span className='inline-block bg-gray-100 text-[9px] uppercase font-bold px-1.5 py-0.5 rounded mt-2 text-gray-500'>
                                                                            {customerAddresses[order.LedCode].addressType}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className='px-6 py-6 border-r border-gray-100 text-center'>
                                                            <div className='flex flex-col items-center gap-3'>
                                                                <span className='text-sm font-bold text-gray-900'>#{order.EntryNo}</span>
                                                                {showSendToDelhiveryBtn && (
                                                                    <button
                                                                        onClick={() => handleSendToDelhivery(order)}
                                                                        disabled={isSendingToDelhivery}
                                                                        className={`px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider rounded-lg transition-all shadow-lg ${isSendingToDelhivery
                                                                            ? 'bg-gray-200 text-gray-500 cursor-not-allowed shadow-none'
                                                                            : 'bg-amber-500 text-white hover:bg-amber-600 shadow-amber-500/20'
                                                                            }`}
                                                                    >
                                                                        {isSendingToDelhivery ? 'Sending...' : 'Send To Delhivery'}
                                                                    </button>
                                                                )}
                                                                {canTrackOrder(tracking) && (
                                                                    <button
                                                                        onClick={() => handleTrackOrder(order.EntryNo, order.LedCode)}
                                                                        className='px-3 py-1.5 bg-black text-white text-[10px] font-bold uppercase tracking-wider rounded-lg hover:bg-gray-800 transition-all shadow-lg shadow-black/10'
                                                                    >
                                                                        Track Order
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className='px-6 py-6 text-center'>
                                                            <div className='flex flex-col items-center gap-2'>
                                                                {tracking ? (
                                                                    <div className='flex flex-col items-center gap-1'>
                                                                        {(() => {
                                                                            const displayStatus = order.isDelivered ? 'Delivered' : tracking.status;
                                                                            const statusColor = getStatusColor(displayStatus);
                                                                            return (
                                                                                <span className={`inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest ${statusColor.replace('text-', 'bg-').replace('-600', '-100')} ${statusColor}`}>
                                                                                    {displayStatus}
                                                                                </span>
                                                                            );
                                                                        })()}
                                                                        {tracking.timestamp && (
                                                                            <span className='text-[10px] font-medium text-gray-400'>
                                                                                {formatTimeAgo(tracking.timestamp)}
                                                                            </span>
                                                                        )}
                                                                        {tracking.location && (
                                                                            <span className='text-[9px] font-bold text-gray-400 uppercase tracking-tight max-w-[160px] text-center break-words whitespace-normal leading-tight' title={tracking.location}>
                                                                                {tracking.location}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex items-center gap-2">
                                                                        <div className="w-4 h-4 border-2 border-gray-100 border-t-black rounded-full animate-spin"></div>
                                                                        <span className="text-[10px] font-bold uppercase text-gray-400">Syncing...</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>



                    {/* Mobile Order List */}
                    <div className='lg:hidden bg-gray-50/50 rounded-3xl mt-5'>
                        {loading ? (
                            <div className='px-6 py-24 text-center'>
                                <div className="flex flex-col items-center gap-4">
                                    <div className="w-12 h-12 border-4 border-gray-100 border-t-black rounded-full animate-spin"></div>
                                    <span className="text-sm font-bold text-gray-400 uppercase tracking-widest">Loading Orders...</span>
                                </div>
                            </div>
                        ) : displayOrders.length === 0 ? (
                            <div className='px-6 py-12 text-center text-gray-400 font-medium'>
                                No orders matching your criteria were found.
                            </div>
                        ) : (
                            displayOrders.map((order, index) => {
                                const tracking = orderTrackingStatus[order.EntryNo];
                                const showSendToDelhiveryBtn = isManifestPending(tracking);
                                const isSendingToDelhivery = !!sendingToDelhivery[order.EntryNo];
                                return (
                                    <div
                                        key={`${index}-${searchItem}-${filterDate}-${status}`}
                                        className='p-6 border-b border-gray-100 bg-white mb-4 rounded-3xl shadow-sm'
                                    >
                                        <div className='flex justify-between items-start mb-6'>
                                            <div className='flex flex-col'>
                                                <span className='text-base font-bold text-gray-900'>{customerNames[order.LedCode] || 'Loading...'}</span>
                                                <span className='text-xs font-bold text-gray-400 uppercase tracking-widest mt-0.5'>ID {order.LedCode}</span>
                                            </div>
                                            <div className='flex flex-col items-end'>
                                                <span className='text-base font-black text-gray-900'>#{order.EntryNo}</span>
                                                <span className='text-[10px] font-bold text-gray-400 px-2 py-0.5 bg-gray-100 rounded-full mt-1'>{formatDate(order.OrderDate)}</span>
                                            </div>
                                        </div>

                                        <div className='space-y-6'>
                                            {/* Products for Mobile */}
                                            <div className='space-y-3'>
                                                <h4 className='text-[10px] font-extrabold uppercase tracking-widest text-gray-400'>Order Items</h4>
                                                <div className='bg-gray-50 rounded-2xl p-4 space-y-4'>
                                                    {(() => {
                                                        const grouped = groupItemsByItemNameAndColor(order, productDetails, productNames);

                                                        // MOBILE SKELETON
                                                        if (grouped.length === 0 && order.data && order.data.length > 0) {
                                                            return (
                                                                <div className="space-y-4 animate-pulse">
                                                                    {[1, 2].map((_, i) => (
                                                                        <div key={i} className="space-y-2">
                                                                            <div className="flex justify-between items-center">
                                                                                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                                                                                <div className="h-3 w-3 bg-gray-200 rounded-full"></div>
                                                                            </div>
                                                                            <div className="flex gap-2">
                                                                                <div className="h-8 w-16 bg-gray-200 rounded-lg"></div>
                                                                                <div className="h-8 w-16 bg-gray-200 rounded-lg"></div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            );
                                                        }

                                                        return grouped.map((itemGroup, itemIdx) => (
                                                            <div key={itemIdx} className="space-y-2">
                                                                <div className='flex justify-between items-center'>
                                                                    <span className='text-sm font-bold text-gray-900'>{itemGroup.itemName}</span>
                                                                    <ExternalLink className="w-3.5 h-3.5 text-gray-400" />
                                                                </div>
                                                                <div className='flex flex-wrap gap-2'>
                                                                    {itemGroup.colors.map((colorGroup, colorIdx) => (
                                                                        <div key={colorIdx} className='bg-white px-3 py-1.5 rounded-xl border border-gray-100 shadow-sm'>
                                                                            <div className='flex items-center gap-2 mb-1'>
                                                                                <div className='w-2 h-2 rounded-full' style={{ backgroundColor: modifiedColors[colorGroup.color]?.hex || '#ccc' }} />
                                                                                <span className='text-[10px] font-bold uppercase text-gray-600'>{colorGroup.color}</span>
                                                                            </div>
                                                                            {colorGroup.items.map((item, sizeIdx) => (
                                                                                <span key={sizeIdx} className='text-[10px] font-medium text-gray-500 block'>
                                                                                    Size {item.size} � {item.quantity}
                                                                                </span>
                                                                            ))}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ));
                                                    })()}
                                                </div>
                                            </div>

                                            {/* Shipping for Mobile */}
                                            <div className='space-y-3'>
                                                <h4 className='text-[10px] font-extrabold uppercase tracking-widest text-gray-400'>Shipping Details</h4>
                                                <div className='flex flex-col gap-2'>
                                                    <div className='flex items-center gap-2 text-gray-900 font-bold text-xs'>
                                                        <svg className='w-3.5 h-3.5 text-gray-400' fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                                                        {order.PhoneNo}
                                                    </div>
                                                    {customerAddresses[order.LedCode] && (
                                                        <div className='text-xs text-gray-500 font-medium leading-relaxed bg-gray-50/50 p-3 rounded-2xl'>
                                                            <p className='text-gray-900 font-semibold mb-1'>{customerAddresses[order.LedCode].address}</p>
                                                            <p>{customerAddresses[order.LedCode].locality}, {customerAddresses[order.LedCode].city}</p>
                                                            <p>{customerAddresses[order.LedCode].district}, {customerAddresses[order.LedCode].pincode}</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Actions & Status for Mobile */}
                                            <div className='pt-4 border-t border-gray-100 flex justify-between items-center'>
                                                {tracking ? (
                                                    <div className='flex items-center gap-2'>
                                                        <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest ${getStatusColor(tracking.status).replace('text-', 'bg-').replace('-600', '-100')} ${getStatusColor(tracking.status)}`}>
                                                            {tracking.status}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <span className='text-[10px] font-bold uppercase text-gray-400'>Syncing...</span>
                                                )}

                                                <div className='flex items-center gap-2'>
                                                    {showSendToDelhiveryBtn && (
                                                        <button
                                                            onClick={() => handleSendToDelhivery(order)}
                                                            disabled={isSendingToDelhivery}
                                                            className={`px-4 py-2 text-[10px] font-bold uppercase tracking-wider rounded-xl transition-all ${isSendingToDelhivery
                                                                ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                                                : 'bg-amber-500 text-white hover:bg-amber-600'
                                                                }`}
                                                        >
                                                            {isSendingToDelhivery ? 'Sending...' : 'Send'}
                                                        </button>
                                                    )}

                                                    {canTrackOrder(tracking) && (
                                                        <button
                                                            onClick={() => handleTrackOrder(order.EntryNo, order.LedCode)}
                                                            className='px-4 py-2 bg-black text-white text-[10px] font-bold uppercase tracking-wider rounded-xl hover:bg-gray-800 transition-all shadow-lg shadow-black/10'
                                                        >
                                                            Track Order
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>

            {showTracking && (
                <div className="fixed inset-0 w-screen h-screen overflow-auto bg-black bg-opacity-50 flex justify-center items-center p-5 md:p-0 z-[9999]" onClick={(e) => {
                    e.stopPropagation()
                    setShowTracking(null)
                }}>
                    <TrackingOrders order_id={showTracking} oLedCode={oLedCode} setShowTracking={setShowTracking} />
                </div>
            )}
        </div>
    );
}

export default Dashboard;




